<div class="py-2 pt-md-0 pb-md-4 contract-item-container" data-e2e="contracts-options">
  @if (getIcon()) {
  <div>
    <img alt="" [src]="getIcon()" />
  </div>
  }
  <div class="row">
    <div class="col-12 col-md-6 col-lg-5">
      <h3 class="mb-0">{{terminatedContractViewModel?.offerName}}</h3>
      <div class="lead text-gray3">{{terminatedContractViewModel?.detail}}</div>
      @if (terminatedContractViewModel?.member) {
      <div class="text-smagenta1 font-weight-bold">{{terminatedContractViewModel.member.displayName}}</div>
      }
    </div>
  </div>
</div>
